export default __webpack_public_path__ + "static/us-0fffdc4abb38bf1ad94ba5e1295d53c7.svg";